import { render, staticRenderFns } from "./configurations-form.component.vue?vue&type=template&id=1bc7f4f7&scoped=true"
import script from "./configurations-form.component.vue?vue&type=script&lang=ts"
export * from "./configurations-form.component.vue?vue&type=script&lang=ts"
import style0 from "./configurations-form.component.vue?vue&type=style&index=0&id=1bc7f4f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7f4f7",
  null
  
)

export default component.exports